import { render } from "./musica_fondo_ingles.vue?vue&type=template&id=0d273aff&scoped=true"
import script from "./musica_fondo_ingles.vue?vue&type=script&lang=js"
export * from "./musica_fondo_ingles.vue?vue&type=script&lang=js"

import "./musica_fondo_ingles.vue?vue&type=style&index=0&id=0d273aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d273aff"]])

export default __exports__